import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Name from "./columns/Name"
import Sku from "./columns/Sku"
import DateCreated from "./columns/DateCreated"
import Status from "./columns/Status"
import Actions from "./columns/Actions"
import SelectedCheckbox from "./columns/SelectedCheckbox"
import ExportBy from "./columns/ExportBy"
import Procedure from "./columns/Procedure"
import CommitTime from "./columns/CommitTime"

class TableRow extends Component {
    render() {
        const {item, onRefresh, arrSelected, onSelected} = this.props
        const { production_process } = { ...item }
        const { name: productionProcessName } = { ...production_process }

        const partner = item.partner && item.partner.name
        let mex
        if(typeof item.is_mex === 'boolean') {
            mex = item.is_mex === false ? 'No' : 'Yes'
        } else {
            mex = '-'
        }

        return (
            <tr className="TableRow">
                <SelectedCheckbox id={item._id} arrSelected={arrSelected} onSelected={onSelected}/>
                <Sku sku={item.sku} id={item._id}/>
                <Name name={item.name}/>
                <Procedure procedure={item.procedure}/>
                <td className='ProductionProcess'>{productionProcessName || '-'}</td>
                <td>{mex}</td>
                <td>{partner ||'-' }</td>
                <CommitTime commitmentTime={item.commitment_time}/>
                <td>{item.commitment_time_fast_production || '-' }</td>
                <DateCreated createdAt={item.created_at}/>
                <Status isActive={item.is_active}/>
                <ExportBy exportBy={item.export_by}/>
                <Actions item={item} onRefresh={onRefresh}/>
            </tr>
        )
    }
}

TableRow.propTypes = {
    item: PropTypes.object
}

export default TableRow
